export enum BridgeStep {
  LOADING,
  WAITING_SIGNATURE,
  APPROVED_REQUIRED,
  TRACKING,
  REJECTED_BY_THE_USER,
  INSUFFICIENT_FUNDS,
  UNKNOWN_ERROR,
}
